import { render, staticRenderFns } from "./BoxInfo.vue?vue&type=template&id=2dd0c39e&scoped=true&"
import script from "./BoxInfo.vue?vue&type=script&lang=js&"
export * from "./BoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./BoxInfo.vue?vue&type=style&index=0&id=2dd0c39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0c39e",
  null
  
)

export default component.exports